import React from 'react';
import styles from "./splashScreen.module.scss";

const SplashScreen = () => {
  return (
    <div className={styles.container}>
        <div className={styles.text}>KRIHA MEGAM</div>
    </div>
  )
}

export default SplashScreen